import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { WhatIncludes } from '../components/WhatIncludes';
import { Benefits } from '../components/Benefits';
import { Offer } from '../components/Offer';
import { Testimonials } from '../components/Testimonials';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  // Initialize Meta Pixel on page load
  useMetaPixel();
  return <div className="w-full min-h-screen bg-white" data-id="element-269">
      <Navigation data-id="element-270" />
      <Hero data-id="element-271" />
      <WhatIncludes data-id="element-272" />
      <Benefits data-id="element-273" />
      <Offer data-id="element-274" />
      <Testimonials data-id="element-275" />
      <FinalCTA data-id="element-276" />
      <Footer data-id="element-277" />
    </div>;
}